import * as actionTypes from 'store/actionTypes';
import storageService from 'services/storage.service';
import referralService from 'services/referral.service';
import config from 'utils/config';

// eslint-disable-next-line import/prefer-default-export
export const getBonusesListAction = (body = {}) => async (dispatch) => {
  const token = storageService.getItem(config.userTokenKey);
  if (token) {
    dispatch({
      type: actionTypes.GET_BONUSES_LIST_REQUEST,
    });

    try {
      const response = await referralService.getReferralBonusesList(body);

      dispatch({
        type: actionTypes.GET_BONUSES_LIST_SUCCESS,
        payload: response,
      });

      return response;
    } catch (e) {
      dispatch({
        type: actionTypes.GET_BONUSES_LIST_FAIL,
      });
      throw e;
    }
  } else {
    dispatch({
      type: actionTypes.GET_BONUSES_LIST_FAIL,
    });
  }
};
